import { autorun, reaction, action as action$1, computed as computed$1, observable as observable$1 } from 'mobx';
import { __decorate } from 'tslib';
import { TemplateRef, ViewContainerRef, Input, Directive, NgModule } from '@angular/core';

// import { mobxAngularDebug } from '../utils/mobx-angular-debug';
import * as ɵngcc0 from '@angular/core';
let MobxAutorunDirective = class MobxAutorunDirective {
    constructor(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.templateBindings = {};
        this.allAutorunOptions = [
            'delay',
            'scheduler',
            'requiresObservable',
            'name',
            'onError'
        ];
    }
    ngOnInit() {
        this.view = this.viewContainer.createEmbeddedView(this.templateRef);
        if (this.dispose) {
            this.dispose();
        }
        if (this.shouldDetach()) {
            this.view.detach();
        }
        this.autoDetect(this.view);
        // mobxAngularDebug(this.view, this.dispose);
    }
    shouldDetach() {
        return this.mobxAutorun && this.mobxAutorun.detach;
    }
    autoDetect(view) {
        const opts = this.getAutorunOptions();
        this.dispose = autorun(() => view.detectChanges(), opts);
    }
    getAutorunOptions() {
        return Object.keys(this.mobxAutorun || {}).reduce((opts, current) => {
            if (this.allAutorunOptions.includes(current)) {
                opts[current] = this.mobxAutorun[current];
            }
            return opts;
        }, {});
    }
    ngOnDestroy() {
        if (this.dispose) {
            this.dispose();
        }
    }
};
MobxAutorunDirective.ɵfac = function MobxAutorunDirective_Factory(t) { return new (t || MobxAutorunDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
MobxAutorunDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MobxAutorunDirective, selectors: [["", "mobxAutorun", ""]], inputs: { mobxAutorun: "mobxAutorun" } });
MobxAutorunDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input()
], MobxAutorunDirective.prototype, "mobxAutorun", void 0);

let MobxReactionDirective = class MobxReactionDirective extends MobxAutorunDirective {
    constructor(templateRef, viewContainer) {
        super(templateRef, viewContainer);
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    autoDetect(view) {
        const opts = Object.assign({ fireImmediately: true }, this.mobxReactionOptions);
        this.dispose = reaction(this.mobxReaction, () => {
            view.detectChanges();
        }, opts);
    }
};
MobxReactionDirective.ɵfac = function MobxReactionDirective_Factory(t) { return new (t || MobxReactionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
MobxReactionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MobxReactionDirective, selectors: [["", "mobxReaction", ""]], inputs: { mobxReaction: "mobxReaction", mobxReactionOptions: "mobxReactionOptions" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MobxReactionDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input()
], MobxReactionDirective.prototype, "mobxReaction", void 0);
__decorate([
    Input()
], MobxReactionDirective.prototype, "mobxReactionOptions", void 0);

const DIRECTIVES = [MobxAutorunDirective, MobxReactionDirective];
let MobxAngularModule = class MobxAngularModule {
};
MobxAngularModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MobxAngularModule });
MobxAngularModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MobxAngularModule_Factory(t) { return new (t || MobxAngularModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MobxAutorunDirective, [{
        type: Directive,
        args: [{ selector: '[mobxAutorun]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { mobxAutorun: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MobxReactionDirective, [{
        type: Directive,
        args: [{ selector: '[mobxReaction]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { mobxReaction: [{
            type: Input
        }], mobxReactionOptions: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MobxAngularModule, { declarations: [MobxAutorunDirective, MobxReactionDirective], exports: [MobxAutorunDirective, MobxReactionDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MobxAngularModule, [{
        type: NgModule,
        args: [{
                declarations: DIRECTIVES,
                exports: DIRECTIVES
            }]
    }], null, null); })();

/*
 * Public API Surface of mobx-angular
 */
// Re-export mobx operators to be able to use inside components with AOT:
function actionInternal(...args) {
    return action$1(...args);
}
const action = Object.assign(actionInternal, action$1);
function computedInternal(...args) {
    return computed$1(...args);
}
const computed = Object.assign(computedInternal, computed$1);
function observableInternal(...args) {
    return observable$1(...args);
}
const observable = Object.assign(observableInternal, observable$1);

/**
 * Generated bundle index. Do not edit.
 */

export { MobxAngularModule, MobxAutorunDirective, MobxReactionDirective, action, actionInternal, computed, observable };

//# sourceMappingURL=mobx-angular.js.map